var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import qs from 'qs';
import { initAuthService, initLowauthService } from '../../apis';
import { getBasePath, cookie } from '../../utils';
import Config from '../../config';
export const getBaseHeaders = () => {
    const headers = {
        Env: window.appInfo && window.appInfo.env,
    };
    if (cookie.get('authorization')) {
        headers.Authorization = cookie.get('authorization');
    }
    return headers;
};
let _map;
let authService;
let lowauthService;
const Service = {
    start() {
        _map = null;
        authService = initAuthService();
        lowauthService = initLowauthService();
        window.authService = authService;
    },
    getUserInfo() {
        let userInfoPromise = null;
        if (window.appInfo.hasUserCenter) {
            userInfoPromise = lowauthService.GetUser({
                headers: getBaseHeaders(),
                config: {
                    noErrorTip: true,
                },
            });
        }
        else {
            userInfoPromise = authService.GetUser({
                headers: getBaseHeaders(),
                config: {
                    noErrorTip: true,
                },
            });
        }
        userInfoPromise = userInfoPromise
            .then((result) => {
            var _a;
            // 兼容新的返回格式
            let userInfo;
            if ((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.Data) {
                userInfo = result.data.Data;
            }
            else {
                userInfo = result === null || result === void 0 ? void 0 : result.Data;
            }
            if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.UserId) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId)) {
                userInfo.UserId = userInfo.userId;
                userInfo.UserName = userInfo.userName;
            }
            if (userInfo && !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.DisplayName) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.UserName)) {
                userInfo.DisplayName = userInfo.UserName;
            }
            const $global = Config.globalProperties.get('$global') || {};
            const frontendVariables = $global.frontendVariables || {};
            frontendVariables.userInfo = userInfo;
            $global.userInfo = userInfo;
            return userInfo;
        })
            .catch((e) => {
            userInfoPromise = null;
            throw e;
        });
        return userInfoPromise;
    },
    getUserResources(DomainName) {
        let userResourcesPromise = null;
        if (window.appInfo.hasAuth) {
            userResourcesPromise = lowauthService
                .GetUserResources({
                headers: getBaseHeaders(),
                query: {},
                config: {
                    noErrorTip: true,
                },
            })
                .then((result) => {
                // 兼容新的返回格式
                const data = (result === null || result === void 0 ? void 0 : result.data) || result;
                let resources = [];
                // 初始化权限项
                _map = new Map();
                if (Array.isArray(data)) {
                    resources = data.filter((resource) => (resource === null || resource === void 0 ? void 0 : resource.resourceType) === 'ui');
                    resources.forEach((resource) => _map.set(resource.resourceValue, resource));
                }
                return resources;
            });
        }
        else {
            // 这个是非下沉应用，调用的是Nuims的接口，此处需非常注意Resource大小写情况，开发时需关注相关测试用例是否覆盖
            userResourcesPromise = authService
                .GetUserResources({
                headers: getBaseHeaders(),
                query: {
                    DomainName,
                },
                config: {
                    noErrorTip: true,
                },
            })
                .then((res) => {
                _map = new Map();
                const resources = res.Data.items.reduce((acc, _a) => {
                    var { ResourceType, ResourceValue } = _a, item = __rest(_a, ["ResourceType", "ResourceValue"]);
                    if (ResourceType === 'ui') {
                        acc.push(Object.assign(Object.assign({}, item), { ResourceType,
                            ResourceValue, resourceType: ResourceType, resourceValue: ResourceValue })); // 兼容大小写写法，留存大写，避免影响其他隐藏逻辑
                    }
                    return acc;
                }, []);
                // 初始化权限项
                resources.forEach((resource) => _map.set(resource === null || resource === void 0 ? void 0 : resource.ResourceValue, resource));
                return resources;
            });
        }
        return userResourcesPromise;
    },
    getKeycloakLogoutUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let logoutUrl = '';
            const basePath = getBasePath();
            if (window.appInfo.hasUserCenter) {
                const res = yield lowauthService.getAppLoginTypes({
                    query: {
                        Action: 'GetTenantLoginTypes',
                        Version: '2020-06-01',
                        TenantName: window.appInfo.tenant,
                    },
                });
                const KeycloakConfig = res === null || res === void 0 ? void 0 : res.Data.Keycloak;
                if (KeycloakConfig) {
                    logoutUrl = `${(_a = KeycloakConfig === null || KeycloakConfig === void 0 ? void 0 : KeycloakConfig.config) === null || _a === void 0 ? void 0 : _a.logoutUrl}?redirect_uri=${window.location.protocol}//${window.location.host}${basePath}/login`;
                }
            }
            else {
                const res = yield authService.getNuimsTenantLoginTypes({
                    query: {
                        Action: 'GetTenantLoginTypes',
                        Version: '2020-06-01',
                        TenantName: window.appInfo.tenant,
                    },
                });
                const KeycloakConfig = res === null || res === void 0 ? void 0 : res.Data.find((item) => item.LoginType === 'Keycloak');
                if (KeycloakConfig) {
                    logoutUrl = `${(_b = KeycloakConfig === null || KeycloakConfig === void 0 ? void 0 : KeycloakConfig.extendProperties) === null || _b === void 0 ? void 0 : _b.logoutUrl}?redirect_uri=${window.location.protocol}//${window.location.host}${basePath}/login`;
                }
            }
            return logoutUrl;
        });
    },
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            const sleep = (t) => new Promise((r) => setTimeout(r, t));
            if (window.appInfo.hasUserCenter) {
                const logoutUrl = yield Service.getKeycloakLogoutUrl();
                localStorage.setItem('logoutUrl', logoutUrl);
                if (logoutUrl) {
                    window.location.href = logoutUrl;
                    yield sleep(1000);
                }
                else {
                    return lowauthService
                        .Logout({
                        headers: getBaseHeaders(),
                    })
                        .then(() => {
                        // 用户中心，去除认证和用户名信息
                        cookie.erase('authorization');
                        cookie.erase('username');
                    });
                }
            }
            else {
                const logoutUrl = yield Service.getKeycloakLogoutUrl();
                localStorage.setItem('logoutUrl', logoutUrl);
                if (logoutUrl) {
                    window.location.href = logoutUrl;
                    yield sleep(1000);
                }
                else {
                    return authService
                        .Logout({
                        headers: getBaseHeaders(),
                    })
                        .then(() => {
                        cookie.erase('authorization');
                        cookie.erase('username');
                    });
                }
            }
        });
    },
    loginH5(data) {
        return authService.LoginH5(Object.assign({ headers: getBaseHeaders() }, data));
    },
    getNuims(query) {
        return authService.GetNuims({
            headers: getBaseHeaders(),
            query,
        });
    },
    getConfig() {
        return authService.GetConfig({
            headers: getBaseHeaders(),
        });
    },
    // 处理数据的参数转化
    parse: qs.parse,
    stringify: qs.stringify,
    /**
     * 权限服务是否初始化
     */
    isInit() {
        return !!_map;
    },
    /**
     * 初始化权限服务
     */
    init(domainName) {
        return Service.getUserInfo().then(() => Service.getUserResources(domainName));
    },
    /**
     * 是否有权限
     * @param {*} authPath 权限路径，如 /dashboard/entity/list
     */
    has(authPath) {
        return (_map && _map.has(authPath)) || false;
    },
    _setCustomResources(list = []) {
        _map = new Map();
        list.forEach((resource) => _map.set(resource.resourceValue, Object.assign(Object.assign({}, resource), { ResourceType: resource.resourceType, ResourceValue: resource.resourceValue })));
    },
};
export default Service;
